import React from 'react'
import { Button } from 'components'
import { API_BASE } from 'consts'

const HREF_BASE = `${API_BASE}/login`

export default class UpgradeScopesLink extends React.Component {
  static propTypes = {
    scopes: React.PropTypes.array.isRequired,
    label: React.PropTypes.string.isRequired,
    className: React.PropTypes.string
  }

  static contextTypes = {
    currentUser: React.PropTypes.object
  }

  shop_param() {
    return `?shop=${this.context.currentUser.username.replace(/^shopify-/, "")}`
  }

  scopes_params() {
    return this.props.scopes.map(scope => `upgrade_scopes[]=${scope}`).join("&")
  }

  href() {
    return `${HREF_BASE}${this.shop_param()}&${this.scopes_params()}&origin=${window.location}`
  }

  render() {
    return <Button 
      label={this.props.label}
      className={this.props.className}
      buttonType={this.props.buttonType}
      onTouchTap={() => { window.location = this.href() }} />
  }
}



// WEBPACK FOOTER //
// ./app/components/UpgradeScopesLink.js